import { Image, Button, Card, Input, Form, FormProps } from "antd";
import styled from "styled-components";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { loginAsync, selectStatus } from "./loginSlice";
import {sha256} from 'js-sha256';
import logo from '../../images/nexaid_logo_bgless.png';
import { setToken, setUsername } from "../home/homeSlice";
import { redirect, useNavigate } from "react-router-dom";
import RoutePath from "../../app/routing/routes.path";



const LoginScreen = styled.div`
    width: 100%;
    height: 100%;
    background-image: linear-gradient(to bottom left, #3f3f3f, #373737);
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    flex-direction: row;
`;

const BrandCard = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-right: 10hmin;
`
const LogoImage = styled.img`
    height: 30vmin;
`

type FieldType = {
    userId?: string;
    password?: string;
};

export default function Login() {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    
    const onFinish: FormProps<FieldType>['onFinish'] = async (values) => {
        console.log('Success:', values);
        let loginBody:any = {};
        loginBody.ts = Date.now();
        loginBody.userId = values.userId;
        const pHash = sha256(`${values.password}`);
        loginBody.fHash = sha256(`${pHash}${loginBody.ts}`);

        const loginInfo:any = await dispatch(loginAsync({loginBody}));
        if (!loginInfo.error) {
            const token = loginInfo?.payload?.data?.data?.token;
            const userData = loginInfo?.payload?.data?.data?.userData;
            const username = userData?.name;
            localStorage.setItem('token', token);
            localStorage.setItem('userData', userData);
            localStorage.setItem('username', username);
            setUsername(username);
            setToken(token);
            navigate(RoutePath.home);
        }
    };

    const onFinishFailed: FormProps<FieldType>['onFinishFailed'] = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    const token = localStorage.getItem('token');
    const username = localStorage.getItem('username');
    if (token && username) {
        navigate(RoutePath.home);
    }

    return <LoginScreen style={{padding: 30, boxSizing: 'border-box'}}>
        <BrandCard>
            <LogoImage src={logo}/>
            <h1 style={{color: 'white'}}>NEXAID</h1>
        </BrandCard>
        <Card title="Login" style={{ maxWidth: 600, width: '100%' }}>
            <Form
                name="basic"
                layout="vertical"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <Form.Item
                    label="Username"
                    name="userId"
                    rules={[{ required: true, message: 'Please input your username!', whitespace: true }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="Password"
                    name="password"
                    rules={[{ required: true, message: 'Please input your password!' }]}
                >
                    <Input.Password />
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    </LoginScreen>
}